module.exports = __webpack_public_path__ + "img/copy.e2c34631.png";